/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HealthCareServiceRequest } from '../../models/health-care-service-request';
import { HealthCareServiceResponse } from '../../models/health-care-service-response';

export interface HealthFindrHealthCareServicesPost$Params {
      body?: HealthCareServiceRequest
}

export function healthFindrHealthCareServicesPost(http: HttpClient, rootUrl: string, params?: HealthFindrHealthCareServicesPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<Array<HealthCareServiceResponse>>> {
  const rb = new RequestBuilder(rootUrl, healthFindrHealthCareServicesPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<Array<HealthCareServiceResponse>>;
    })
  );
}

healthFindrHealthCareServicesPost.PATH = '/HealthFindr/HealthCareServices';
